/**
 * Nearby Vuex
 */

import * as API from '@/endpoints'
import Utils from '@/utils.js'
import Axios from 'axios'
import Vue from 'vue'
import VueCookie from 'vue-cookie'

export default {
  namespaced: true,
  state: {
    nearbyPeople: {
      data: {},
      isLoading: false
    },
    nearBy: {},
    nearByWork: {},
    isLoadingNearBy: false,
    showEnableNearby: false
  },
  mutations: {
    setMorePeopleNearby (state, v) {
      state.nearbyPeople.data.next_link = v.next_link
      for (var x = 0; x < v.data.length; x++) {
        state.nearbyPeople.data.data.push(v.data[x])
      }
    },
    setNearByPeople (state, v) {
      Vue.set(state.nearbyPeople, 'data', v)
    },
    setNearByPeopleLoader (state, v) {
      Vue.set(state.nearbyPeople, 'isLoading', v)
    },
    setShowEnableNearby (state, v) {
      Vue.set(state, 'showEnableNearby', v)
    },
    setNearByWork (state, v) {
      Vue.set(state, 'nearByWork', v)
    },
    setIsLoadingNearBy (state, v) {
      Vue.set(state, 'isLoadingNearBy', v)
    },
    setNearBy (state, v) {
      Vue.set(state, 'nearBy', v)
    }
  },
  actions: {
    getNextPageNerby ({ commit, dispatch, state }, { url }) {
      return new Promise((resolve, reject) => {
        commit('setNearByPeopleLoader', true)
        Axios.get(url).then(
          res => {
            commit('setMorePeopleNearby', res.data)
            commit('setNearByPeopleLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setNearByPeopleLoader', false)
            reject(error)
          }
        )
      })
    },
    getNearbyPeople ({commit, dispatch}, {query}) {
      return new Promise((resolve, reject) => {
        commit('setNearByPeopleLoader', true)
        Axios.get(API.endpoints.nearby + query).then(
          res => {
            commit('setNearByPeople', res.data)
            commit('setNearByPeopleLoader', false)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setNearByPeopleLoader', false)
            reject(error)
          }
        )
      })
    },
    getPermissionState ({ commit, dispatch, state }, loc) {
      return new Promise((resolve, reject) => {
        var showNearby = function () {
          commit('setShowEnableNearby', false)
          Promise.all([
            dispatch('getNearBy', { latitude: loc.latitude, longitude: loc.longitude }),
            dispatch('getNearByWork')
          ]).then(function (values) {
            commit('setIsLoadingNearBy', false)
            commit('setShowEnableNearby', false)
          })
        }

        var showToAllowNearby = function () {
          commit('setShowEnableNearby', true)
        }

        var checkPermissionNearby = function (result) {
          if (result.state == 'granted') showNearby()
          else showToAllowNearby()
        }

        navigator.permissions
          .query({ name: 'geolocation' })
          .then(function (result) {
            checkPermissionNearby(result)
            result.onchange = function () {
              checkPermissionNearby(result)
            }
          })
      })
    },

    getNearByWork ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        Axios.get(API.endpoints.nearbyTotal + '/work?radius=5').then(
          res => {
            commit('setNearByWork', res.data)
            resolve(res.data)
          },
          error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            reject(error)
          }
        )
      })
    },

    getNearBy ({ commit, dispatch, state }, loc) {
      return new Promise((resolve, reject) => {
        var latitude = loc.latitude
        var longitude = loc.longitude

        var callNearby = function () {
          var url =
            API.endpoints.nearbyTotal +
            '?latitude=' +
            latitude +
            '&longitude=' +
            longitude +
            '&radius=1&has_total_users=1&per_page=1'
          Axios.get(url).then(
            res => {
              commit('setNearBy', res.data)
              resolve(res.data)
            },
            error => {
              dispatch('exceptionHandling', { _err: error }, { root: 1 })
              reject(error)
            }
          )
        }
        var sucess = function (position) {
          latitude = position.coords.latitude
          longitude = position.coords.longitude
          callNearby()
        }
        var error = function () {
          callNearby()
        }

        navigator.geolocation.getCurrentPosition(sucess, error)
      })
    }
  }
}
